import { useState, FormEvent } from "react";
import Button from "../../components/molecules/Button";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { AppState } from "../../store/root.reducer";
import { ConfirmResetPassword } from "./store/auth.actions";
import Heading from "../../components/atoms/Heading";
import { Input, Form } from "../../components/molecules/Form";
import * as AuthActions from './store/auth.actions';

export const ConfirmResetPasswordPage = () => {
  const auth = useSelector((state: AppState) => state.auth);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');

  const [code, setCode] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");

  const onSubmit = () => {
    dispatch(
      ConfirmResetPassword({ navigate, code, newPassword, token: auth.token })
    );
  };

  const onResend = (e: any) => {
    e.preventDefault();
    // dispatch(AuthActions.ResendResetPassword(auth.token));
    dispatch(AuthActions.ResetPassword({ navigate, email: email }));
  }

  return (  
    <>
      <div className="container">
        <Heading h2 className="mt-1">
          Reset Password
        </Heading>
        <Form>
          <Input
            type="password"
            title="Type in your new password"
            placeholder="Enter new password"
            value={newPassword}
            onChange={(value: string) => setNewPassword(value)}
          />
          <Input
            type="text"
            title="We've sent a password reset code to your email address.&#10;Please type the code below"
            className="multiline-title"
            placeholder="Enter 6 digits code from email"
            value={code}
            onChange={(value: string) => setCode(value)}
          />
          <Button
            disabled={auth.loading}
            className="btn btn-success mt-1"
            type="button"
            onClick={onSubmit}
          >
            Submit
          </Button>
        </Form>
        <div className="mt-4">
          <div>Didn't receive a code? Please check your spam folder.</div>
          <Link 
            to="#"
            onClick={(e) => onResend(e)} 
            className="mt-1 text-decoration-none"
          >
            Resend email
          </Link>
        </div>
      </div>
    </>
  );
};
